import { Component, Input, OnInit } from '@angular/core'
import { IChangeLogModel, IRequestLogModel } from '../../../../models/history-records-change.model'
import { PaginationModel } from '../../../../models/pagination.model'
import { HttpResponseHandlerService } from '../../../../services/http-response-handler.service'
import { HttpErrorResponse } from '@angular/common/http'
import IHistoryTrackingService from './i-history-tracking.service'

type DisplayType = 'parent' | 'child'

@Component({
    selector: 'app-history-tracking',
    templateUrl: './history-tracking.component.html',
    standalone: false
})
export class HistoryTrackingComponent implements OnInit {
  @Input() serviceInstance: IHistoryTrackingService
  @Input() getHistoryEventsParams: any
  @Input() objectLabel: string = 'Main Object'

  private _historyEvents: IRequestLogModel[] = []
  private _historyEventsCollectionSize: number = 0
  private _isLoadingHistoryEvents: boolean = false
  private _historyEventItems: IChangeLogModel[] = []
  private _historyEventItemsCollectionSize: number = 0
  private _isLoadingHistoryEventItems: boolean = false

  private _mode: DisplayType
  private _historyEventsPagination: PaginationModel = new PaginationModel({ no: 1, size: 10 })
  private _historyEventItemsPagination: PaginationModel = new PaginationModel({ no: 1, size: 10 })
  private _processId: string

  public get isLoadingHistoryEvents(): boolean {
    return this._isLoadingHistoryEvents
  }

  public get isLoadingHistoryEventItems(): boolean {
    return this._isLoadingHistoryEventItems
  }

  public get page(): number {
    return this._historyEventsPagination.no
  }

  public get pageSize(): number {
    return this._historyEventsPagination.size
  }

  public get historyEvents(): IRequestLogModel[] {
    return this._historyEvents
  }

  public get historyEventsCollectionSize(): number {
    return this._historyEventsCollectionSize
  }

  public get historyEventItems(): IChangeLogModel[] {
    return this._historyEventItems
  }

  public get historyEventItemsCollectionSize(): number {
    return this._historyEventItemsCollectionSize
  }

  public get pageItems(): number {
    return this._historyEventItemsPagination.no
  }

  public get pageSizeItems(): number {
    return this._historyEventItemsPagination.size
  }

  public get mode(): DisplayType {
    return this._mode
  }

  constructor(private responseHandlerService: HttpResponseHandlerService) {}

  public onHistoryEventsPageChanged(event: number): void {
    this._historyEventsPagination.no = event
    this.getHistoryEvents()
  }

  private getHistoryEvents(): void {
    this._isLoadingHistoryEvents = true
    this.serviceInstance
      .getHistoryEvents(this._historyEventsPagination, this.getHistoryEventsParams)
      .subscribe({
        next: (resource: { count: number; items: IRequestLogModel[] }) => {
          this._isLoadingHistoryEvents = false
          this._historyEvents = resource.items
          this._historyEventsCollectionSize = resource.count
        },
        error: (error: HttpErrorResponse) => {
          this._isLoadingHistoryEvents = false
          this.responseHandlerService.notifyError(error)
        },
      })
  }

  /** History Event Items */

  public onGetEventItems(processId: string): void {
    this._mode = 'child'
    this._processId = processId
    this.getHistoryEventItems(processId)
  }

  private getHistoryEventItems(processId: string): void {
    this._isLoadingHistoryEventItems = true
    this.serviceInstance
      .getHistoryEventItems(processId, this._historyEventItemsPagination)
      .subscribe({
        next: (resource: { count: number; items: IRequestLogModel[] }) => {
          this._isLoadingHistoryEventItems = false
          this._historyEventItems = resource.items
          this._historyEventItemsCollectionSize = resource.count
        },
        error: (error: HttpErrorResponse) => {
          this._isLoadingHistoryEventItems = false
          this.responseHandlerService.notifyError(error)
        },
      })
  }

  public onHistoryEventItemsPageChanged(event: number): void {
    this._historyEventItemsPagination.no = event
    this.getHistoryEventItems(this._processId)
  }

  private resetEventItems(): void {
    this._processId = undefined
    this._historyEventItems = []
    this._historyEventItemsPagination = new PaginationModel({ no: 1, size: 10 })
  }

  public onGoBack(): void {
    this._mode = 'parent'
    this.resetEventItems()
  }

  ngOnInit(): void {
    this._mode = 'parent'
    this.getHistoryEvents()
  }
}
